import React from 'react';
import Login from './Login';

function LoginPages({ onAdminLogin, onGoToHome }) {
  return (
    <Login
      onAdminLogin={onAdminLogin}
      onGoToHome={onGoToHome}
    />
  );
}

export default LoginPages;
